import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
type StopOrPauseProps = {
    isOpen: boolean;
    onClose: () => void;
    onDeleteSubscription: () => void;
    onPausedSubscription: () => void;
};

export const StopOrPause = ({
    isOpen,
    onClose,
    onDeleteSubscription,
    onPausedSubscription,
}: StopOrPauseProps) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Cambiar frecuencia de envío</DialogTitle>
                </DialogHeader>
                <Button
                    className="mx-10"
                    variant="default"
                    type="button"
                    onClick={onPausedSubscription}
                >
                    Pausar tu suscripción
                </Button>
                <Button
                    className="mx-10"
                    variant="destructive"
                    type="button"
                    onClick={onDeleteSubscription}
                >
                    Terminar tu suscripción
                </Button>
            </DialogContent>
        </Dialog>
    );
};
